import React from "react";

// Components
import Button from "components/UiKit/Button";
import FieldText from "components/UiKit/FieldText";
import FieldCheckbox from "components/UiKit/FieldCheckbox";

// Lib
import { Controller } from "react-hook-form";

// Constants
import { defValueFilter } from "constans/search";

// Interface
interface IFilter {
  reset?: any,
  errors?: any,
  control?: any,
  register?: any,
  typeTab?: string,
  linkers?: boolean,
  compounds?: boolean,
  innerDisabled?: boolean,
}

const Filter: React.FC<IFilter> = (props) => {
  const {
    reset,
    errors,
    control,
    typeTab,
    register,
    compounds = false
  } = props;

  const handlerClearFilter = () => {
    const convertConfigMarvin = JSON.parse(localStorage.getItem("configMarvin") || "{}");

    reset({
      typeStructure: convertConfigMarvin.typeStructure,
      ...defValueFilter
    });
  };

  const isDisabled = !!Object.values(errors)?.length;

  const isLinkersTab = typeTab !== "linkers";
  const isShow = isLinkersTab && compounds;

  return (
    <div className="filter flex flex-direction-column">
      <div className="flex flex-ai-center mt30 mb30">
        <p className="filter__title">Choose search criteria:</p>

        <div className="flex flex-ai-center" id="structure-search-checkbox">
          <Controller
            name="compounds"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => {
              return (
                <FieldCheckbox
                  label="EBC"
                  value={!!value}
                  name="compounds"
                  className="mr10"
                  isError={!!errors?.compounds}
                  register={register("compounds", { required: "" })}
                  msgError={errors?.compounds ? errors?.compounds.message : ""}
                  onChange={(val: React.ChangeEvent<HTMLInputElement>) => onChange(val)}
                />
              );
            }}
          />

          <Controller
            name="linkers"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => {
              return (
                <FieldCheckbox
                  name="linkers"
                  label="Linkers"
                  value={!!value}
                  isError={!!errors?.linkers}
                  register={register("linkers", { required: "" })}
                  msgError={errors?.linkers ? errors?.linkers.message : ""}
                  onChange={(val: React.ChangeEvent<HTMLInputElement>) => onChange(val)}
                />
              );
            }}
          />
        </div>
      </div>

      {isShow && <div>
        <div className="filter__title mb20">Filters applied to EBC compounds:</div>
        <div className="relative mb40" id="structure-search-filter">
          <div className="filter__block flex flex-ai-center flex-jc-between flex-wrap">
            <div className="flex flex-direction-column">
              <div className="flex flex-ai-center flex-jc-between relative mb20">
                <p
                  title="Molecular Weight"
                  className="filter__input-label mr10"
                >
                  MW:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="0.1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("molecularWeightGte")}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="0.1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("molecularWeightLte")}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.molecularWeightGte || !!errors?.molecularWeightLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>

              <div className="flex flex-ai-center flex-jc-between relative">
                <p
                  className="filter__input-label mr10"
                  title="Calculated octanol/water partition coefficient"
                >
                  cLogP:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="0.01"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("logPGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="0.01"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("logPLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.logPGte || !!errors?.logPLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>
            </div>

            <div className="flex flex-direction-column">
              <div className="flex flex-ai-center flex-jc-between relative mb20">
                <p
                  title="Hydrogen Bond Acceptors"
                  className="filter__input-label mr10"
                >
                  HBA:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("hbaGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("hbaLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.hbaGte || !!errors?.hbaLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>

              <div className="flex flex-ai-center flex-jc-between relative">
                <p
                  title="Hydrogen Bond Donors"
                  className="filter__input-label mr10"
                >
                  HBD:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("hbdGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("hbdLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.hbdGte || !!errors?.hbdLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>
            </div>

            <div className="flex flex-direction-column">
              <div className="flex flex-ai-center flex-jc-between relative mb20">
                <p
                  title="Rotatable Bonds"
                  className="filter__input-label mr10"
                >
                  RotB:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("rotatableBondCountGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("rotatableBondCountLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.rotatableBondCountGte || !!errors?.rotatableBondCountLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>
                  }
                </div>
              </div>

              <div className="flex flex-ai-center flex-jc-between relative">
                <p
                  className="filter__input-label mr10"
                  title="Topological Polar Surface Area"
                >
                  TPSA:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="0.1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("tpsaGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="0.1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("tpsaLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.tpsaGte || !!errors?.tpsaLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>
            </div>

            <div className="flex flex-direction-column">
              <div className="flex flex-ai-center flex-jc-between relative mb20">
                <p
                  title="Heavy Atom Count"
                  className="filter__input-label mr10"
                >
                  HAC:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("heavyAtomCountGte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("heavyAtomCountLte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.heavyAtomCountGte || !!errors?.heavyAtomCountLte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>

              <div className="flex flex-ai-center flex-jc-between relative">
                <p
                  className="filter__input-label mr10"
                  title="Fraction of sp3 carbon atoms"
                >
                  F<i>sp</i><sup>3</sup>:
                </p>
                <div className="flex flex-ai-center">
                  <FieldText
                    step="0.1"
                    placeholder="min"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("fsp3Gte", { required: true })}
                  />
                  <span className="filter__input-symbol ml10 mr10">÷</span>
                  <FieldText
                    step="0.1"
                    placeholder="max"
                    innerTypeInput="number"
                    className="filter__input"
                    register={register("fsp3Lte", { required: true })}
                  />
                </div>
                <div className="filter__wrapper-error-block flex flex-ai-center flex-jc-between">
                  {(!!errors?.fsp3Gte || !!errors?.fsp3Lte) &&
                    <div className="filter__error-text">
                      Please choose relevant boundary values
                    </div>}
                </div>
              </div>
            </div>
          </div>

          <Button
            isSvg
            variable="icon"
            icon="deleteSvg"
            color="error"
            title="Clear filters"
            onPress={handlerClearFilter}
            className="filter__btn-delete"
          />
        </div>
      </div>}

      <div className="flex flex-ai-center flex-jc-end full-width">
        <Button
          variable="info"
          type="submit"
          label="Show Results"
          disabled={isDisabled}
          id="structure-search-search"
        />
      </div>
    </div>
  );
};
export default Filter;

